import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';


const useStylesDataIconsTooltip = makeStyles((theme) => ({
    arrow: {
        color: "#3F3F46",
    },
    tooltip: {
        backgroundColor: "#3F3F46",
        boxShadow:"box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06);",
        borderRadius:"8px",
        textAlign:"center",
        fontStyle:"normal",
        fontWeight:"500",
        fontSize: "12px",
    },
}));


function DataIconsTooltip(props) {
    const classes = useStylesDataIconsTooltip();

    return <Tooltip arrow classes={classes} {...props}/>;
}

export default DataIconsTooltip;